/** 标题等单行字段去掉 Markdown 标记，避免输入框里露出 *。 */
export function stripMarkdownMarkers(text: string): string {
  return (text || '')
    .replaceAll('**', '')
    .replaceAll('__', '')
    .replaceAll('`', '')
    .replaceAll(/^>\s?/gm, '')
    .replaceAll(/\s+/g, ' ')
    .trim()
}

/**
 * markdown-it 不会把 `中文**术语**中文` 识别为粗体。
 * 保存前补齐 Markdown 边界，使管理后台、Web 和 Native 使用同一份规范内容。
 */
export function normalizeMarkdownEmphasisSpacing(text: string): string {
  const letterOrNumber = /[\p{L}\p{N}]/u

  return (text || '').replaceAll(
    /\*\*(\S(?:[^\n]*?\S)?)\*\*/g,
    (match: string, inner: string, offset: number, source: string) => {
      const before = source[offset - 1]
      const after = source[offset + match.length]
      const leftSpace = before && letterOrNumber.test(before) ? ' ' : ''
      const rightSpace = after && letterOrNumber.test(after) ? ' ' : ''

      return `${leftSpace}**${inner}**${rightSpace}`
    }
  )
}
